import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { parseISO, differenceInMinutes, format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

const LightningStrikeMarker = ({ position, timestamp, timezone, distance_km }) => {
  const now = new Date();
  // Parse timestamp as UTC
  const strikeTimeUTC = parseISO(timestamp.endsWith('Z') ? timestamp : `${timestamp}Z`);
  const isValidDate = !isNaN(strikeTimeUTC.getTime());
  const ageMinutes = isValidDate ? differenceInMinutes(now, strikeTimeUTC) : Infinity;

  // Determine opacity based on age
  let opacity;
  if (!isValidDate || ageMinutes > 31) {
    return null; // Hide if invalid or too old
  } else if (ageMinutes <= 6) opacity = 1.0;   // Fully visible
  else if (ageMinutes <= 11) opacity = 0.8;   // 80% opacity
  else if (ageMinutes <= 16) opacity = 0.6;   // 60% opacity
  else if (ageMinutes <= 21) opacity = 0.4;   // 40% opacity
  else if (ageMinutes <= 26) opacity = 0.2;   // 20% opacity
  else if (ageMinutes <= 31) opacity = 0.1;   // 10% opacity

  // Convert UTC time to selected timezone for tooltip
  const strikeTimeZoned = isValidDate ? toZonedTime(strikeTimeUTC, timezone) : null;
  const formattedDateTime = isValidDate ? format(strikeTimeZoned, 'MM/dd/yyyy, HH:mm') : 'Invalid Date';
  const distanceMiles = distance_km != null ? (distance_km * 0.621371).toFixed(1) : 'N/A'; // Convert km to miles

  const lightningIcon = L.divIcon({
    className: 'lightning-strike',
    html: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f39c12" stroke-width="2" opacity="${opacity}">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
      </svg>
    `,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });

  return (
    <Marker position={position} icon={lightningIcon}>
      <Popup offset={[0, -12]} autoPan={false} closeButton={false}>
        <div style={{
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          border: '1px solid rgba(0, 0, 0, 0.75)',
          color: '#FFFFFF',
          padding: '2px 5px',
          borderRadius: '4px',
          fontSize: '12px',
        }}>
          <strong>Date-Time:</strong> {formattedDateTime}<br />
          <strong>Distance:</strong> {distanceMiles} mi
        </div>
      </Popup>
    </Marker>
  );
};

export default LightningStrikeMarker;
